/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import clsx from "clsx";
import {
    Box,
    Button,
    Checkbox,
    FormControlLabel,
    InternalStandardProps,
    Theme,
    Typography,
} from "@mui/material";
import { CheckCircleOutline, RadioButtonUnchecked } from "@mui/icons-material";
import { createStyles, makeStyles } from "@mui/styles";
import { useSnackbar } from "notistack";
import {
    useAudioGifts,
    useVideoGifts,
    useGlobalGifts,
    useAudiosToSend,
    useVideosToSend,
    useSendGifts,
    useReceivedMemberAudioGifts,
    useReceivedMemberVideoGifts,
    useReceivedProspectAudioGifts,
    useReceivedProspectVideoGifts,
    useProspectingUser,
} from "JS/React/Hooks/Gifts";
import {
    usePurchasableCourses,
    useGlobalCourses,
    usePurchasedGiftCourses,
    useReceivedCourses,
} from "JS/React/Hooks/Course/Course";
import { useRouting } from "JS/React/Hooks/Routes";
import { AppHeader } from "JS/React/Components/AppHeader";
import { AppContentListItemType } from "JS/React/Components/AppContentListItem";
import sortableHeader from "JS/React/HOC/SortableHeader";
import {
    ColumnSort,
    getColumnSort,
    sortData,
    Sorting,
    sortViaAcquiredDate,
} from "JS/Types";
import { BottomSheet } from "JS/React/Components/BottomSheet";
import {
    PurchasedGfitCourse,
    PurchasedGiftCourseDetail,
    SendGift,
    AllTabs,
    Members,
    Course,
    ReceivedGift,
} from "JS/Models";
import { SelectMembersDialog } from "JS/React/Components/ContentPurchase/SelectMembersDialog";
import { AlertDialog } from "JS/React/Components/AlertDialog";
import { AppBackdropProgress } from "JS/React/Components/Progress/AppBackdropProgress";
import { getGiftCategory } from "JS/Helpers";
import { useSearchedLosMembers } from "JS/React/Hooks/Media";
import { useGlobalNavStack } from "JS/React/Hooks/NavStack";
import { useGetFavorites, useGlobalFavorites } from "JS/React/Hooks/Favorites";
import { useGlobalAudios } from "JS/React/Hooks/Audio";
import { useGlobalVideos } from "JS/React/Hooks/Video";
import { Layout } from "../Layout";
import { giftCat, GiftCategories } from ".";
import { ListingComponent } from "../Audios/ListingComponent";
import { GiftNavStack } from "JS/Models/navStack";
import { useDownloadedContentStatus } from "../Videos/DownloadedContentStatus";

export interface CategoriesProps
    extends InternalStandardProps<
        React.DetailedHTMLProps<
            React.HTMLAttributes<HTMLDivElement>,
            HTMLDivElement
        >
    > {}

export enum SortableTitle {
    A_Z = "A-Z",
    RELEASED = "Released",
    ACQUIRED = "Acquired",
    PLAYED = "Played",
}

export enum receivedSortableTitle {
    A_Z = "A-Z",
    RELEASED = "Released",
}

const SortableHeader = sortableHeader<HTMLSpanElement>("span");

enum ProsTabs {
    AUDIOS = "Audio",
    VIDEOS = "Video",
}

const mergeQuantity = (baseArray = [], quantityArray = []) => {
    const quantityMap = new Map(
        quantityArray
            .filter((item) => item?.nid != null)
            .map((item) => [String(item?.nid), item?.quantity ?? 0]),
    );

    return baseArray.map((item) => ({
        ...item,
        quantity:
            item?.nid != null ? quantityMap.get(String(item?.nid)) ?? 0 : 0,
    }));
};

export const GiftsContentListing = (props: any) => {
    const params: any = useParams();
    const {
        categoryId,
        selectedTab,
    }: {
        categoryId: string;
        selectedTab: AllTabs;
    } = params;
    const {
        setGlobalGiftsCategoryStack,
        resetGlobalGiftsCategoryStack,
        giftsStack,
    } = useGlobalNavStack();
    const setStack = (stack: GiftNavStack) => {
        setGlobalGiftsCategoryStack(stack, categoryId);
    };
    const { homeStack } = useGlobalNavStack();
    const { enqueueSnackbar } = useSnackbar();
    const Tabs: any =
        categoryId === GiftCategories.PURCHASABLE_BY_MEMBERS ||
        categoryId === GiftCategories.SEND_MEMBER ||
        categoryId === GiftCategories.RECEIVED_AS_MEMBER
            ? AllTabs
            : ProsTabs;
    const classes = useStyles(props);
    const { className, ...rest } = props;
    const [filteredGifts, setFilteredGifts] = useState([]);
    const [searchQuery, setSearchQuery] = useState<string>(
        giftsStack[categoryId]?.searchQuery
            ? giftsStack[categoryId]?.searchQuery
            : "",
    );
    const [selectMultiple, setSelectMultiple] = useState<boolean>(false);
    const [selectedItems, setSelectedItems] = useState<SendGift[]>([]);
    const [isSuccessDialogOpen, setIsSuccessDialogOpen] =
        useState<boolean>(false);
    const [sentQuantity, setSentQuantity] = useState<number>(null);

    const [headerTitle, setHeaderTitle] = useState("");

    const history = useHistory();
    const { linkProvider } = useRouting();

    const {
        purchasableMemberAudios,
        purchasableMemberVideos,
        purchasableProspectAudios,
        purchasableProspectVideos,
        audiosToSend,
        videosToSend,
        receivedMemberAudios,
        receivedMemberVideos,
        receivedProspectAudios,
        receivedProspectVideos,
        setGlobalGifts,
    } = useGlobalGifts();
    const {
        purchasableCoursesForMembers,
        coursesToSend,
        receivedCourses,
        setGlobalPurchasedCourses,
    } = useGlobalCourses();

    const { onListItemClick } = useHandlers(categoryId, selectedTab);

    const { favNids } = useGlobalFavorites();
    const { loading: favLoading } = useGetFavorites(!!favNids?.length);
    const { isProsUser, loading: loadingProsStatus } = useProspectingUser(
        categoryId !== GiftCategories.RECEIVED_AS_PROSPECT,
    );

    const setSelectedTab = (tab: AllTabs) => {
        history.replace(linkProvider.react.gifts().listing(categoryId, tab));
    };

    const { loading: receivedProspectAudioGiftsLoading } =
        useReceivedProspectAudioGifts(
            !isProsUser ||
                categoryId !== GiftCategories.RECEIVED_AS_PROSPECT ||
                selectedTab !== AllTabs.AUDIOS,
        );
    const { loading: receivedProspectVideoGiftsLoading } =
        useReceivedProspectVideoGifts(
            !isProsUser ||
                categoryId !== GiftCategories.RECEIVED_AS_PROSPECT ||
                selectedTab !== AllTabs.VIDEOS,
        );

    const { loading: receivedMemberAudioGiftsLoading } =
        useReceivedMemberAudioGifts(
            categoryId !== GiftCategories.RECEIVED_AS_MEMBER ||
                selectedTab !== AllTabs.AUDIOS,
        );
    const { loading: receivedMemberVideoGiftsLoading } =
        useReceivedMemberVideoGifts(
            categoryId !== GiftCategories.RECEIVED_AS_MEMBER ||
                selectedTab !== AllTabs.VIDEOS,
        );
    const { loading: receivedCoursesLoading } = useReceivedCourses(
        categoryId !== GiftCategories.RECEIVED_AS_MEMBER ||
            selectedTab !== AllTabs.COURSES,
    );

    const { loading: audioLoading } = useAudioGifts(
        categoryId === GiftCategories.PURCHASABLE_BY_MEMBERS ||
            categoryId === GiftCategories.SEND_MEMBER
            ? "GiftMP3"
            : "GiftProsMP3",
        (categoryId !== GiftCategories.PURCHASABLE_BY_MEMBERS &&
            categoryId !== GiftCategories.PURCHASABLE_BY_PROSPECTS) ||
            selectedTab !== AllTabs.AUDIOS,
    );
    const { loading: videoLoading } = useVideoGifts(
        categoryId === GiftCategories.PURCHASABLE_BY_MEMBERS ||
            categoryId === GiftCategories.SEND_MEMBER
            ? "GiftVideo"
            : "GiftProsVideo",
        (categoryId !== GiftCategories.PURCHASABLE_BY_MEMBERS &&
            categoryId !== GiftCategories.PURCHASABLE_BY_PROSPECTS) ||
            selectedTab !== AllTabs.VIDEOS,
    );
    const { loading: purchasedCoursesLoading } = usePurchasedGiftCourses(
        (categoryId !== GiftCategories.SEND_MEMBER &&
            categoryId !== GiftCategories.PURCHASABLE_BY_MEMBERS &&
            categoryId !== GiftCategories.PURCHASABLE_BY_PROSPECTS) ||
            selectedTab !== AllTabs.COURSES,
    );
    const { loading: courseLoading } = usePurchasableCourses(
        categoryId !== GiftCategories.PURCHASABLE_BY_MEMBERS ||
            selectedTab !== AllTabs.COURSES,
    );

    const { loading: audiosToSendLoading } = useAudiosToSend(
        categoryId === GiftCategories.PURCHASABLE_BY_MEMBERS ||
            categoryId === GiftCategories.SEND_MEMBER
            ? "GiftMP3"
            : "GiftProsMP3",
        (categoryId !== GiftCategories.SEND_MEMBER &&
            categoryId !== GiftCategories.PURCHASABLE_BY_MEMBERS &&
            categoryId !== GiftCategories.PURCHASABLE_BY_PROSPECTS) ||
            selectedTab !== AllTabs.AUDIOS,
    );
    const { loading: videosToSendLoading } = useVideosToSend(
        categoryId === GiftCategories.PURCHASABLE_BY_MEMBERS ||
            categoryId === GiftCategories.SEND_MEMBER
            ? "GiftVideo"
            : "GiftProsVideo",
        (categoryId !== GiftCategories.SEND_MEMBER &&
            categoryId !== GiftCategories.PURCHASABLE_BY_MEMBERS &&
            categoryId !== GiftCategories.PURCHASABLE_BY_PROSPECTS) ||
            selectedTab !== AllTabs.VIDEOS,
    );
    const { resumeUserBundles, resumeUserAudios } = useGlobalAudios();
    const { resumeUserVideos } = useGlobalVideos();

    const [dialogs, setDialogs] = useState({
        transactionComplete: false,
        selectMembers: false,
    });

    const [selectedMembers, setSelectedMembers] = useState<Members[]>([]);

    const { searchLosResults, searchQueryLos, setSearchQueryLos } =
        useSearchedLosMembers(
            categoryId !== GiftCategories.PURCHASABLE_BY_MEMBERS &&
                categoryId !== GiftCategories.SEND_MEMBER,
        );

    const { sendGiftToUser, loading: sendingGifts } = useSendGifts();

    const [sorting, setSorting] = useState<Sorting>(
        giftsStack[categoryId]?.sorting,
    );

    const onSortChange = (columnSort: ColumnSort, oldOrder: number) => {
        setSorting([columnSort]);
        setGlobalGiftsCategoryStack(
            {
                sorting: [columnSort],
            },
            categoryId,
        );
    };

    const isLoading = () => {
        if (selectedTab === Tabs.AUDIOS) {
            if (categoryId !== GiftCategories.SEND_MEMBER)
                if (categoryId === GiftCategories.RECEIVED_AS_PROSPECT)
                    return (
                        loadingProsStatus ||
                        (receivedProspectAudioGiftsLoading &&
                            receivedProspectAudios.length === 0)
                    );
                else if (categoryId !== GiftCategories.RECEIVED_AS_MEMBER)
                    return audioLoading;
                else
                    return (
                        receivedMemberAudioGiftsLoading &&
                        receivedMemberAudios.length === 0
                    );
            return audiosToSendLoading;
        }
        if (selectedTab === Tabs.VIDEOS) {
            if (categoryId !== GiftCategories.SEND_MEMBER)
                if (categoryId === GiftCategories.RECEIVED_AS_PROSPECT)
                    return (
                        loadingProsStatus ||
                        (receivedProspectVideoGiftsLoading &&
                            receivedProspectVideos.length === 0)
                    );
                else if (categoryId !== GiftCategories.RECEIVED_AS_MEMBER)
                    return videoLoading;
                else
                    return (
                        receivedMemberVideoGiftsLoading &&
                        receivedMemberAudios.length === 0
                    );
            return videosToSendLoading;
        }
        if (selectedTab === Tabs.COURSES) {
            if (categoryId !== GiftCategories.SEND_MEMBER)
                if (categoryId !== GiftCategories.RECEIVED_AS_MEMBER)
                    return courseLoading;
                else
                    return (
                        receivedCoursesLoading && receivedCourses.length === 0
                    );
            return purchasedCoursesLoading;
        }
    };

    const handleGiftCheckChanged = (nid: string, checked: boolean) => {
        if (checked) {
            const gift = filteredGifts.find((g) => g.nid === nid);
            setSelectedItems((prevState) => [
                ...prevState,
                {
                    nid: gift.nid,
                    sku: gift.sku_id,
                    title: gift.title,
                    category: getGiftCategory(selectedTab),
                },
            ]);
        } else
            setSelectedItems((prevState) =>
                prevState?.filter((item) => item.nid !== nid),
            );
    };

    useEffect(() => {
        setHeaderTitle(giftCat[categoryId].title);
        if (selectedTab === Tabs.AUDIOS) {
            if (categoryId === GiftCategories.RECEIVED_AS_MEMBER) {
                setFilteredGifts(receivedMemberAudios);
            } else if (categoryId === GiftCategories.RECEIVED_AS_PROSPECT) {
                setFilteredGifts(receivedProspectAudios);
            } else if (categoryId === GiftCategories.SEND_MEMBER) {
                const toRenderAudioGifts = audiosToSend?.filter(
                    (ag) => +ag.quantity > 0,
                );
                setFilteredGifts(toRenderAudioGifts);
            } else if (categoryId === GiftCategories.PURCHASABLE_BY_MEMBERS) {
                const merged = mergeQuantity(
                    purchasableMemberAudios,
                    audiosToSend,
                );
                setFilteredGifts(merged);
            } else {
                const merged = mergeQuantity(
                    purchasableProspectAudios,
                    audiosToSend,
                );
                setFilteredGifts(merged);
            }
        } else if (selectedTab === Tabs.VIDEOS) {
            if (categoryId === GiftCategories.RECEIVED_AS_MEMBER) {
                setFilteredGifts(receivedMemberVideos);
            } else if (categoryId === GiftCategories.RECEIVED_AS_PROSPECT) {
                setFilteredGifts(receivedProspectVideos);
            } else if (categoryId === GiftCategories.SEND_MEMBER) {
                const toRenderVideoGifts = videosToSend?.filter(
                    (vg) => +vg.quantity > 0,
                );
                setFilteredGifts(toRenderVideoGifts);
            } else if (categoryId === GiftCategories.PURCHASABLE_BY_MEMBERS) {
                const merged = mergeQuantity(
                    purchasableMemberVideos,
                    videosToSend,
                );
                setFilteredGifts(merged);
            } else {
                const merged = mergeQuantity(
                    purchasableProspectVideos,
                    videosToSend,
                );
                setFilteredGifts(merged);
            }
        } else if (selectedTab === Tabs.COURSES) {
            if (categoryId === GiftCategories.RECEIVED_AS_MEMBER)
                setFilteredGifts(receivedCourses);
            else if (categoryId == GiftCategories.SEND_MEMBER) {
                const toRenderCourseGifts = (coursesToSend || []).filter(
                    (ag) => Number(ag?.quantity ?? 0) > 0,
                );
                setFilteredGifts(toRenderCourseGifts);
            } else
                setFilteredGifts(
                    mergeQuantity(purchasableCoursesForMembers, coursesToSend),
                );
        }
    }, [
        purchasableMemberAudios,
        purchasableMemberVideos,
        audiosToSend,
        videosToSend,
        purchasableCoursesForMembers,
        coursesToSend,
        selectedTab,
        categoryId,
        receivedCourses,
        receivedMemberAudios,
        receivedMemberVideos,
        receivedProspectAudios,
        receivedProspectVideos,
        purchasableProspectAudios,
        purchasableProspectVideos,
    ]);

    const searchResults = useMemo(() => {
        const gifts = filteredGifts?.filter(
            (d) =>
                d.title
                    .toLocaleLowerCase()
                    .includes(searchQuery.toLocaleLowerCase().trim()) ||
                d.description
                    .toLocaleLowerCase()
                    .includes(searchQuery.toLocaleLowerCase().trim()),
        );
        if (sorting[0].col === "acquired_date")
            return sortViaAcquiredDate(gifts, sorting);
        return sortData(gifts, sorting);
    }, [filteredGifts, searchQuery, sorting]);

    useEffect(() => {
        setGlobalGiftsCategoryStack(
            {
                searchQuery: searchQuery,
            },
            categoryId,
        );
    }, [searchResults]);

    useEffect(() => {
        setSelectedItems([]);
    }, [selectMultiple, selectedTab]);

    const handleSelectMembers = () => {
        setDialogs({
            ...dialogs,
            selectMembers: true,
        });
    };

    const onToggleItemSelect = (value) => {
        if (
            selectedMembers.findIndex(
                (x) => x.member_id === value.member_id,
            ) !== -1
        ) {
            let tempArray = [...selectedMembers];
            tempArray.splice(
                tempArray.findIndex((x) => x.member_id === value.member_id),
                1,
            );
            setSelectedMembers(tempArray);
        } else {
            setSelectedMembers([value]);
        }
    };

    const onCloseSelectMembers = () => {
        setDialogs({
            ...dialogs,
            transactionComplete: false,
            selectMembers: false,
        });
    };

    const updateSentGiftsQuantity = () => {
        if (selectedTab === Tabs.AUDIOS) {
            const updatedSentAudios = audiosToSend?.map((sag) => {
                return !!selectedItems?.find((i) => i.sku === sag.sku_id)
                    ? { ...sag, quantity: +sag.quantity - 1 }
                    : { ...sag };
            });
            setGlobalGifts({ audiosToSendList: updatedSentAudios });
        } else if (selectedTab === Tabs.VIDEOS) {
            const updatedSentVideos = videosToSend?.map((svg) => {
                return !!selectedItems?.find((i) => i.sku === svg.sku_id)
                    ? { ...svg, quantity: +svg.quantity - 1 }
                    : { ...svg };
            });
            setGlobalGifts({ videosToSendList: updatedSentVideos });
        } else if (selectedTab === Tabs.COURSES) {
            const updatedPurchasedGifts = coursesToSend?.map((pgc) => {
                if (!!selectedItems?.find((i) => i.sku === pgc.sku_id)) {
                    const quantity: number = +pgc.quantity - 1;
                    return { ...pgc, quantity };
                } else {
                    return { ...pgc };
                }
            });
            setGlobalPurchasedCourses({
                coursesToSend: updatedPurchasedGifts,
            });
        }
    };

    const onSendSelectedMembers = async () => {
        if (selectedMembers.length === 1) {
            sendGiftToUser(
                selectedItems,
                selectedMembers,
                selectedTab === AllTabs.AUDIOS
                    ? "GiftMP3"
                    : selectedTab === AllTabs.VIDEOS
                    ? "GiftVideo"
                    : "GiftCourse",
            ).then(() => {
                setSentQuantity(selectedItems?.length);
                setSelectMultiple(false);
                setIsSuccessDialogOpen(true);
                updateSentGiftsQuantity();
                onCloseSelectMembers();
            });
        } else {
            enqueueSnackbar("Please select at-least one LOS Member.", {
                variant: "warning",
            });
        }
    };

    const handleSuccessDialogClosed = () => {
        setIsSuccessDialogOpen(false);
        setSelectedItems([]);
        setSelectedMembers([]);
        setSentQuantity(null);
    };

    const contentItemType: AppContentListItemType =
        categoryId === GiftCategories.SEND_MEMBER
            ? "gift"
            : categoryId === GiftCategories.RECEIVED_AS_MEMBER ||
              categoryId === GiftCategories.RECEIVED_AS_PROSPECT
            ? "receivedGift"
            : "purchasableCourses";

    const isResumeable = (filteredGift: ReceivedGift) => {
        if (
            categoryId === GiftCategories.RECEIVED_AS_MEMBER ||
            categoryId === GiftCategories.RECEIVED_AS_PROSPECT
        ) {
            if (selectedTab === AllTabs.AUDIOS) {
                if (+filteredGift?.no_of_files > 1) {
                    let filterResumeBundle =
                        resumeUserBundles &&
                        resumeUserBundles.filter(
                            (x) => x.nid === filteredGift.nid,
                        );
                    if (filterResumeBundle.length > 0) {
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    if (
                        resumeUserAudios &&
                        resumeUserAudios.filter(
                            (x) => x.nid === filteredGift.nid,
                        ).length > 0
                    ) {
                        const resumeData = resumeUserAudios.find(
                            (x) => x.nid === filteredGift.nid,
                        );
                        return !!resumeData;
                    } else {
                        return false;
                    }
                }
            } else {
                if (
                    resumeUserVideos &&
                    resumeUserVideos.filter((x) => x.nid === filteredGift.nid)
                        .length > 0
                ) {
                    const resumeData = resumeUserVideos.find(
                        (x) => x.nid === filteredGift.nid,
                    );
                    return !!resumeData;
                } else {
                    return false;
                }
            }
        }
    };

    useEffect(() => {
        window.scrollTo(0, 500);
        window.scrollTo(0, 0);
    }, [isLoading()]);

    useEffect(() => {
        if (
            !loadingProsStatus &&
            isProsUser !== null &&
            !isProsUser &&
            categoryId === GiftCategories.RECEIVED_AS_PROSPECT
        )
            history.replace(linkProvider.react.gifts().sync());
    }, [isProsUser, loadingProsStatus]);

    const useAudiosDownloadHelperData = () => {
        const { getDownloadedStatusById } = useDownloadedContentStatus(
            searchResults,
            "audio",
        );
        return getDownloadedStatusById;
    };

    const isContentLoaded = !(isLoading() || favLoading);

    return (
        <Layout>
            <div
                className={clsx(
                    className,
                    classes.root,
                    selectMultiple && classes.bottomSheetPadding,
                )}
                {...rest}
            >
                <AppHeader
                    title={headerTitle || "Gifts"}
                    canGoBack
                    searchable={true}
                    searchQuery={searchQuery}
                    setSearchQuery={setSearchQuery}
                    tabs={Tabs}
                    selectedTab={selectedTab}
                    setSelectedTab={setSelectedTab}
                    showTabs={!dialogs?.selectMembers}
                    searchPlaceholder={`Search ${selectedTab}s by title or description`}
                    onBackClick={() => {
                        resetGlobalGiftsCategoryStack(categoryId);
                        if (!homeStack?.isHomeTrack) {
                            setFilteredGifts([]);
                            history.push(linkProvider.react.gifts().index());
                        } else {
                            history.replace(linkProvider.react.home());
                        }
                    }}
                />
                {!dialogs?.selectMembers && (
                    <BottomSheet open={selectMultiple}>
                        <Button
                            disabled={selectedItems.length <= 0}
                            onClick={handleSelectMembers}
                            className={clsx(classes.bottomSheetBtn)}
                        >
                            SEND
                        </Button>
                    </BottomSheet>
                )}

                {categoryId !== GiftCategories.RECEIVED_AS_MEMBER &&
                    categoryId !== GiftCategories.RECEIVED_AS_PROSPECT && (
                        <Box display={"flex"} justifyContent={"space-around"}>
                            <SortableHeader
                                upDirection="asc"
                                downDirection="desc"
                                sort={getColumnSort(sorting, {
                                    col: "title",
                                    position: sorting.length,
                                })}
                                onSortChanged={onSortChange}
                            >
                                <span>A-Z</span>
                            </SortableHeader>
                            <SortableHeader
                                upDirection="desc"
                                downDirection="asc"
                                sort={getColumnSort(sorting, {
                                    col: "release_date",
                                    position: sorting.length,
                                })}
                                onSortChanged={onSortChange}
                            >
                                <span>Released</span>
                            </SortableHeader>
                            <SortableHeader
                                upDirection="desc"
                                downDirection="asc"
                                sort={getColumnSort(sorting, {
                                    col: "acquired_date",
                                    position: sorting.length,
                                })}
                                onSortChanged={onSortChange}
                            >
                                <span>Acquired</span>
                            </SortableHeader>
                        </Box>
                    )}
                {categoryId === GiftCategories.SEND_MEMBER &&
                    !dialogs?.selectMembers && (
                        <Box className={clsx(classes.sendCheckboxContainer)}>
                            <FormControlLabel
                                onChange={() =>
                                    setSelectMultiple((prevState) => !prevState)
                                }
                                className={clsx(classes.checkboxControlLabel)}
                                control={
                                    <Checkbox
                                        checked={selectMultiple}
                                        icon={
                                            <RadioButtonUnchecked
                                                className={clsx(
                                                    classes.checkedIcon,
                                                )}
                                            />
                                        }
                                        checkedIcon={
                                            <CheckCircleOutline
                                                className={clsx(
                                                    classes.checkedIcon,
                                                )}
                                            />
                                        }
                                    />
                                }
                                label="Send Multiple Gifts"
                            />
                        </Box>
                    )}
                {isContentLoaded && (
                    <ListingComponent
                        listContent={searchResults as Course[]}
                        searchQuery={searchQuery}
                        showSortHeader={false}
                        setGlobalStack={setStack}
                        globalStack={giftsStack}
                        isResumeable={isResumeable}
                        favoritesContent={favNids}
                        handleListItemClick={onListItemClick}
                        getDownloadHelperData={useAudiosDownloadHelperData}
                        controlType={selectedTab.toLowerCase()}
                        onGiftCheckChanged={handleGiftCheckChanged}
                        selectMode={selectMultiple}
                        selectedItems={selectedItems.map((s) => s.nid)}
                        categoryId={categoryId}
                        listHeight={
                            categoryId === GiftCategories.SEND_MEMBER
                                ? "55vh"
                                : undefined
                        }
                        contentType={contentItemType}
                        parentSort={sorting}
                    />
                )}

                {isContentLoaded && dialogs?.selectMembers && (
                    <SelectMembersDialog
                        open={true}
                        searchable={true}
                        searchPlaceholder="Search by name or LTD ID"
                        searchQuery={searchQueryLos}
                        setSearchQuery={setSearchQueryLos}
                        selectedMembers={selectedMembers}
                        checkboxList={searchLosResults}
                        onToggleItemSelect={onToggleItemSelect}
                        onSend={onSendSelectedMembers}
                        onClose={onCloseSelectMembers}
                        giftSendLoading={sendingGifts}
                        singleSelect
                    />
                )}

                {!isContentLoaded && (
                    <AppBackdropProgress
                        open={true}
                        backdropText={`Fetching Gifts`}
                    />
                )}
            </div>
            {isSuccessDialogOpen && (
                <AlertDialog fixed onClose={handleSuccessDialogClosed}>
                    <Typography className={clsx(classes.dialogTypography)}>
                        Send Complete
                    </Typography>
                    <Typography className={clsx(classes.dialogTypography)}>
                        {sentQuantity || ""} {selectedTab} file
                        {sentQuantity > 1 ? "s were" : " was"} sent to{" "}
                        {selectedMembers[0]?.first_name || ""}{" "}
                        {selectedMembers[0]?.last_name || ""}
                    </Typography>
                </AlertDialog>
            )}
        </Layout>
    );
};

const useHandlers = (categoryId: string, selectedTab: AllTabs) => {
    const history = useHistory();
    const { linkProvider } = useRouting();

    const onListItemClick = (
        gift: ReceivedGift,
        isAutoPlay?: boolean,
        scrollIndex?: number,
    ) => {
        const shouldAutoPlay =
            selectedTab === AllTabs.VIDEOS ? "true" : "false";
        if (
            categoryId === GiftCategories.RECEIVED_AS_MEMBER ||
            categoryId === GiftCategories.RECEIVED_AS_PROSPECT
        ) {
            if (selectedTab === AllTabs.COURSES)
                history.push(
                    linkProvider.react.gifts().courseDetail(gift.nid, {
                        received: "true",
                        giftTab: "true",
                        scrollTo: scrollIndex.toString() || "0",
                    }),
                );
            else if (
                selectedTab === AllTabs.AUDIOS ||
                selectedTab === AllTabs.VIDEOS
            )
                history.push(
                    linkProvider.react
                        .gifts()
                        .giftAudioDetail(
                            gift.nid,
                            categoryId,
                            selectedTab,
                            shouldAutoPlay,
                            {
                                scrollTo: scrollIndex.toString() || "0",
                            },
                        ),
                );
        } else {
            history.push(
                linkProvider.react
                    .gifts()
                    .detail(gift.nid, categoryId, selectedTab, {
                        scrollTo: scrollIndex.toString() || "0",
                    }),
            );
        }
    };

    return {
        onListItemClick,
    };
};

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {},
        grey600: {
            color: theme.palette.grey[600],
        },
        wrapperLoader: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: `calc(100vh - ${theme.footer.height})`,
        },
        sendCheckboxContainer: {
            textAlign: "center",
            margin: "15px 0",
        },
        checkboxControlLabel: {
            "& .MuiTypography-body1": {
                color: `${theme.palette.grey[700]} !important`,
                fontSize: "18px",
            },
        },
        bottomSheetBtn: {
            height: `${theme.footer.height}`,
            width: "100%",
            paddingTop: "0",
            color: theme.palette.grey[600],
            borderTop: `0.2px solid ${theme.palette.grey[300]}`,
            "&.Mui-disabled": {
                color: theme.palette.grey[300],
            },
        },
        checkedIcon: {
            color: theme.palette.grey[700],
        },
        bottomSheetPadding: {
            paddingBottom: "120px",
        },
        dialog: {
            width: "90vw",
        },
        closeBtn: {
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
        },
        dialogContent: {
            marginTop: "20px",
        },
        dialogTypography: {
            textAlign: "center",
            color: theme.palette.grey[600],
            marginBottom: "10px",
        },
        content: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "100%",
            color: `${theme.palette.common.black}`,
        },
    }),
);
